<app-table
module="projects"
pageTitle="Elenco Progetti"
newRecordUrl="projects/projects-edit/new"
editRecordUrl="projects/projects-edit/update/"
deleteRecordUrl="app/projects_delete"
listUrl="app/projects_listall"
nuovoLabel="Nuovo progetto"
listParams="{}"></app-table>
